// extracted by mini-css-extract-plugin
module.exports = {"small":"EthIcon_small__3mdui","medium":"EthIcon_medium__1CRZd","large":"EthIcon_large__3lMwK"};